<template>
	<div class="admin-layout">
		<v-layout class="rounded rounded-md">
			<Header />
			<AdminNav />
			<v-main class="d-flex align-center justify-center" style="min-height: 300px">
				<slot />
			</v-main>
		</v-layout>
	</div>
</template>
<script setup>
import { useAuthGuard } from "~/composables/auth/useAuthGuard"
await useAuthGuard()
</script>
